/**
 * @generated SignedSource<<391f1640a1ef7430233f6bb18eedbef1>>
 * @relayHash c2b6967240e792d10ff23e72b6727055
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b7e2c25aa829fd03e9b5d560c4312e28a8e5aa54ce780210ef76640b395ebdd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8b7e2c25aa829fd03e9b5d560c4312e28a8e5aa54ce780210ef76640b395ebdd",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
